<script> 
import forminput from "@/router/views/FormComponet/forminput.vue";
import formdate from "@/router/views/FormComponet/formdate.vue";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue"; 
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrBirimButceHarcamalari from "@/models/StrBirimButceHarcamalari";
import StrBirimButceHarcamalariTutarlari from "../StrBirimButceHarcamalariTutarlari/Index";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
//import formtreeselect from "@/router/views/FormComponet/formtreeselect.vue";
import formcheckbox from "@/router/views/FormComponet/formcheckbox.vue";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import Treeselect from "@riophae/vue-treeselect";
const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}

import moment from 'moment'; 
import store from "@/state/store"; 
export default {
  mixins: [Api, Sabit, StrBirimButceHarcamalari],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
      Strperformanshedefiid: "",
      Strtabdetfaaliyetid: "",
      guncele:"Add",
      aktif_arama:false,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      }
    };
  },
  components: {
    Loader,
    forminput,
    formdate,
    formcombobox, 
    StrBirimButceHarcamalariTutarlari,
    BirimSecimi,
   // formtreeselect,
    formcheckbox,
    Treeselect
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.guncele="Add";
      if (this.AddEdit == "Edit") {

          
          (this.Strperformanshedefiid = this.FormData.Strperformanshedefiid),
            (this.Strtabdetfaaliyetid = this.FormData.Strtabdetfaaliyetid);
          this.PerformanHedefSecimi();
          (this.FormData.Strperformanshedefiid = this.Strperformanshedefiid),


            this.StratejikFaaliyetSecimi();
          this.FormData.Strtabdetfaaliyetid = this.Strtabdetfaaliyetid;

          //this.secili_personel_yukle();
          this.FormDataType.Gerceklestirmegorevlisiid.ComboDataArray = []
          this.FormDataType.Gerceklestirmegorevlisiid.ComboDataArray.push (
            {
              id:this.FormData.Gerceklestirmegorevlisiid,
              label:this.FormData.GerceklestirmeGorevlisiAdi + " " + this.FormData.GerceklestirmeGorevlisiSoyAdi 
            }
          )

          this.amaclari_yukle(this.FormData.Strperfdonemid)
    
      }else{
        this.aktif_arama=true;
        
      }
      
      let Page= {
        PageNumber: "1",
        PageSize: "1",
        PageDataSize: "1",
      }
      let Filter = "&Eposta=" + this.UserEMail;
      this.ActionsFilterGet({
        Service: "OPersonel",
        Page: Page,
        Filter: Filter,
      }).then((res) => {
        this.FormData.Harcamayetkilisid = res.Data[0].Id; 
      }); 
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) { 
        if (this.AddEdit == "Add" && this.guncele=="Add") { 


            this.ActionsFilterGet({
              Service:"Opersonel", 
              Page:this.Page, 
              Filter:"&Eposta="+store.getters["auth/UserEMail"]
            }).then((res) => {
              if(res){
                    this.FormData.Createdpersonelid=res.Data[0].Id; 
                    this.FormData.Created = moment(new Date()).format('YYYY-MM-DD')
                          this.Post("StrBirimButceHarcamalari", this.FormData).then((res) => {
                            if (res) {
                              //this.$bvModal.hide("StrBirimButceHarcamalari");
                              this.FormData.Id=res.Data;
                              this.guncele = "Edit";
                
                              this.$emit("TableUpdate");
                            }
                          });
                    } 
            });

        } else {
          this.ActionsFilterGet({
              Service:"Opersonel", 
              Page:this.Page, 
              Filter:"&Eposta="+store.getters["auth/UserEMail"]
            }).then((res) => {
              if(res){
                      this.FormData.Lastmodifiedpersonelid=res.Data[0].Id; 
                      this.FormData.Lastmodified = moment(new Date()).format('YYYY-MM-DD')
                      this.Update("StrBirimButceHarcamalari", this.FormData).then((res) => {
                        if (res) {
                          this.$emit("Update", this.FormData);
                          this.$bvModal.hide("StrBirimButceHarcamalari");
                        }
                      });
                    } 
            });
        }
      }
    },
    Get() {
      this.$emit("TableUpdate");
    },
    PerformanHedefSecimi() {
      this.FormDataType.Strtabdetfaaliyetid.ComboDataArray = [];
      this.FormData.Strtabdetfaaliyetid = "";
      this.FormDataType.Strperformanshedefiid.ComboDataArray = [];
      this.FormData.Strperformanshedefiid = "";
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      if (this.FormData.Stramacid) {
        let Filter = "&AmacId=" + this.FormData.Stramacid;
        this.ActionsFilterGet({
          Service: "StrPerfTablo",
          Page: Page,
          Filter: Filter,
        }).then((res) => {
          for (var i = 0; i < res.Data.length; i++) {
            this.FormDataType.Strperformanshedefiid.ComboDataArray.push({
              Id: res.Data[i].Id,
              Value: res.Data[i].Adi+" - "+res.Data[i].Hedefi,
            });
          }
        });
      }
    },
    StratejikFaaliyetSecimi() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

      let Filter = "&Tip=47&Kod=2";

             
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:Filter}).then((res) => {
                for(var i=0; i<res.Data.length; i++)
                {
                 
                        this.FormDataType.Strtabdetfaaliyetid.ComboDataArray = [];
              
                
                        let Filter = "&Tabloids=" + this.FormData.Strperformanshedefiid+"&GostergeTipiId="+res.Data[i].Id;
                        this.ActionsFilterGet({
                          Service: "StrPerfTablolarDetay",
                          Page: Page,
                          Filter: Filter,
                        }).then((res) => {
                          for (var i = 0; i < res.Data.length; i++) {
                            this.FormDataType.Strtabdetfaaliyetid.ComboDataArray.push({
                              Id: res.Data[i].Id,
                              Value: res.Data[i].Gostergesi,
                            });
                          }
                        });



                }
               
            });



      
    },
    amaclari_yukle(donem){
      let Page= {
      PageNumber: "1",
      PageSize: "9999"
    }  
      this.FormDataType.Stramacid.ComboDataArray=[];
      let Filter="&DonemId="+donem;

      this.ActionsFilterGet({"Service":"StrStratejikAmac","Page":Page,Filter}).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.Stramacid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Aciklama})
        }    
    }); 

    },

    personel_loadOptions({ action,  callback }) {
   
      this.options=[];
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {

           this.options = this.FormDataType.Gerceklestirmegorevlisiid.ComboDataArray;

          callback(null, this.options)
        })
      }
    },

    personel_yukle(veri){
      let Page = {
        PageNumber: "1",
        PageSize: "50",
      };
      this.aktif_arama=true;
   
      if (veri.length>=1){

        this.FormDataType.Gerceklestirmegorevlisiid.ComboDataArray=[];

          let Filter = "&Adsoyad="+veri+"&Asc=AdSoyad";
          

          this.ActionsFilterGet({Service:"OPersonel",Page:Page, Filter:Filter}).then(res => {  
            for(var i=0; i<res.Data.length; i++)
              {
                this.FormDataType.Gerceklestirmegorevlisiid.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Adsoyad})
               
              }    
          }); 

      }

    },

    secili_personel_yukle(){
      let Page = {
        PageNumber: "1",
        PageSize: "50",
      };
      this.aktif_arama=false;
     
        this.FormDataType.Gerceklestirmegorevlisiid.ComboDataArray=[];
         
          this.ActionsGet({Service:"OPersonel/"+this.FormData.Gerceklestirmegorevlisiid,Page:Page}).then(res => {  

                this.FormDataType.Gerceklestirmegorevlisiid.ComboDataArray.push ({id:res.Data.Id,label:res.Data.Adsoyad})

                this.aktif_arama=true;
                 
          }); 

    },



  },
  created(){ 


  }
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrBirimButceHarcamalari"
      size="xl"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrBirimButceHarcamalari.AddEdit.FormTitleEdit')
          : $t('StrBirimButceHarcamalari.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    > 


      <Form @submit.prevent="onSubmit">
        <div class="row">
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Baslik"
              :Value="FormData.Baslik"
              :v="$v.FormData.Baslik"
              @input="FormData.Baslik = $event"
            />
          </div>
          <div class="col-md-6">
            <formdate
              :FormDataType="FormDataType.Tarih"
              :Value="FormData.Tarih"
              :v="$v.FormData.Tarih"
              @input="FormData.Tarih = $event"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
             

              <BirimSecimi
                    :title="FormDataType.Birimid.FieldTitle"
                    :sutun="'0'" 
                    :title_class="'mb-3'"
                    :selected="FormData.Birimid" 
                    :v="$v.FormData.Birimid"
                    :YetkiKontrol="1"
                    :multiple="false"
                    :BirimTipId="null"
                    @Secilmis_Idler="FormData.Birimid=$event"
                  />


          </div>  
          <div class="col-md-6">
            
            <formcombobox
              :FormDataType="FormDataType.Donem"
              :Value="FormData.Donem"
              :v="$v.FormData.Donem"
              @input="FormData.Donem = $event"
            />

          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Strperfdonemid"
              :Value="FormData.Strperfdonemid"
              :v="$v.FormData.Strperfdonemid"
              @input="FormData.Strperfdonemid = $event, amaclari_yukle($event)"
            />
          </div>
          <div class="col-md-6">

            <formcombobox
              :FormDataType="FormDataType.Harcamatipiid"
              :Value="FormData.Harcamatipiid"
              :v="$v.FormData.Harcamatipiid"
              @input="FormData.Harcamatipiid = $event"
            />
            
          </div>

        </div>

        <div class="row">
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Stramacid"
              :Value="FormData.Stramacid"
              :v="$v.FormData.Stramacid"
              @input="(FormData.Stramacid = $event), PerformanHedefSecimi()"
            />
          </div>
          <div class="col-md-6">
      
            <formcombobox
              :FormDataType="FormDataType.Ihaleusulleriid"
              :Value="FormData.Ihaleusulleriid"
              :v="$v.FormData.Ihaleusulleriid"
              @input="FormData.Ihaleusulleriid = $event"
            />

          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
      <formcombobox
              :FormDataType="FormDataType.Strperformanshedefiid"
              :Value="FormData.Strperformanshedefiid"
              :v="$v.FormData.Strperformanshedefiid"
              @input="
                (FormData.Strperformanshedefiid = $event),
                  StratejikFaaliyetSecimi()
              "
            />

          </div>

          <div class="col-md-6">  
            <!--
            <formtreeselect
              :name="'Gerceklestirmegorevlisiid'"
              :FormDataType="FormDataType.Gerceklestirmegorevlisiid"
              :Value="FormData.Gerceklestirmegorevlisiid"
              :v="$v.FormData.Gerceklestirmegorevlisiid"
              @input="FormData.Gerceklestirmegorevlisiid = $event"
            />
            -->
            <b-form-group class="mb-3" id="example text"  label="Gerçekleştirme Görevlisi" label-for="text">
            <treeselect 
                name="'Gerceklestirmegorevlisiid'"
                id="'Gerceklestirmegorevlisiid'"
                @search-change="personel_yukle($event)"
                :async="aktif_arama"
                :load-options="personel_loadOptions"
                :options="FormDataType.Gerceklestirmegorevlisiid.ComboDataArray"
                :multiple="false"   
                searchPromptText="Aramak için yazın..."
                placeholder="Seçiniz..." 
                v-model="FormData.Gerceklestirmegorevlisiid"          
                />

                <treeselect-value :value="FormData.Gerceklestirmegorevlisiid" />
                </b-form-group>
            
          </div>


        </div>


        <div class="row">
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Strtabdetfaaliyetid"
              :Value="FormData.Strtabdetfaaliyetid"
              :v="$v.FormData.Strtabdetfaaliyetid"
              @input="FormData.Strtabdetfaaliyetid = $event"
            />
          </div>
          <div class="col-md-6">

            <forminput
          :FormDataType="FormDataType.Aciklama"
          :Value="FormData.Aciklama"
          :v="$v.FormData.Aciklama"
          @input="FormData.Aciklama = $event"
        />
            
          </div>
        </div>

          
        <forminput
          v-if="AddEdit == 'Edit' || guncele=='Edit'"
          :FormDataType="FormDataType.Duzeltmenotu"
          :Value="FormData.Duzeltmenotu"
          :v="$v.FormData.Duzeltmenotu"
          @input="FormData.Duzeltmenotu = $event"
        />

        <formcheckbox
              :FormDataType="FormDataType.Butcedisi"
              :Value="FormData.Butcedisi"
              :v="$v.FormData.Butcedisi"
              @input="FormData.Butcedisi = $event"
            />

            <div class="col-md-12">
          <h6 v-if="!Lastmodifiedadsoyad">Kayıt Yapan Personel: {{ FormData.Createdadsoyad  }} - {{ FormData.Created | formatDateTable }} </h6>
          <h6 v-else>Düzenleme Yapan Personel:  {{ FormData.Lastmodifiedadsoyad  }} - {{ FormData.Lastmodified | formatDateTable  }} </h6>
        
        </div>

        
        <StrBirimButceHarcamalariTutarlari
          v-if="AddEdit == 'Edit' || guncele=='Edit'"
          :ButceHarcamalariId="FormData.Id"
          @TableUpdate="Get()" 
        />

  

        <button class="btn btn-primary" type="submit">
          {{ $t("StrBirimButceHarcamalari.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
